import 'css-chunksrc/client/common/constraintTypeForm/deltaSelect/styles.scss';export default {
  "deltaSelect": "_deltaSelect_3zciq_1",
  "hourValue": "_hourValue_3zciq_11",
  "valueInput": "_valueInput_3zciq_19",
  "input": "_input_3zciq_33",
  "opened": "_opened_3zciq_46",
  "icon": "_icon_3zciq_51",
  "listRoot": "_listRoot_3zciq_59",
  "list": "_list_3zciq_59",
  "delta": "_delta_3zciq_1",
  "selected": "_selected_3zciq_81",
  "name": "_name_3zciq_84"
};